import { createFileRoute } from '@tanstack/react-router';
import { lazy } from '@loadable/component';
import { EnterpriseScopeCounterDiscriminator } from '@mews-commander/data-access';
import { FeatureFlag, TextKey } from '@mews-commander/enums';
import { MewsTeam, RouteType } from '@mews/enums';
import { useFeatureFlag } from '@mews/framework';

const GeneralCountersTable = lazy(
    async () =>
        (await import(/* webpackChunkName: "Counters" */ '@mews-commander/counters/components/GeneralCountersTable'))
            .GeneralCountersTable
);

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Settings/Counters/SystemGenerated')({
    component: Component,
    staticData: {
        title: TextKey.SystemGeneratedCountersPlural,
        owner: MewsTeam.Billing,
        type: RouteType.Frontend,
        excludeBreadcrumb: true,
    },
});

function Component() {
    const isPaymentCorrectionsEnabled = useFeatureFlag(FeatureFlag.paymentConfirmationsEnabled);

    return (
        <GeneralCountersTable
            isSystemGenerated
            counterTypes={[
                EnterpriseScopeCounterDiscriminator.ServiceOrderCounter,
                EnterpriseScopeCounterDiscriminator.AvailabilityBlockCounter,
                EnterpriseScopeCounterDiscriminator.RegistrationCardCounter,
                EnterpriseScopeCounterDiscriminator.FiscalCounter,
                EnterpriseScopeCounterDiscriminator.CorrectionBillCounter,
                ...(isPaymentCorrectionsEnabled
                    ? [EnterpriseScopeCounterDiscriminator.PaymentConfirmationBillCounter]
                    : []),
            ]}
        />
    );
}
